export const Settings = {
    contact: {
        mail: '',
    },
    inputLineBreakNumber: 25,
    emptyChat: 'new chat',
    feedbackMaxLength: 500
} as const

export const titleSizes: Record<number, string> = {
    1: '4xl',
    2: '3xl',
    3: '2xl',
    4: 'xl',
    5: 'l',
    6: 'm',
    7: 's',
}

export const HeaderType = {
    DEFAULT: 'header-default',
    MINIMAL: 'header-minimal',
} as const

export const AssistantTypes = {
    BASIC: 'basic',
    ADVANCED: 'advanced',
} as const

export const RenderOptions = {
    default: 'assistants',
    assistants: 'assistants',
    spaces: 'spaces',
} as const
